<template>
  <members-management-table
    :identifier="selectedPlan.Id + '_membersTable'"
    v-if="selectedPlan !== null && selectedPlan !== undefined"
  ></members-management-table>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MembersManagementTable from "../components/MembersManagementTable";
import { planSetter } from "../mixins/planSetter";
export default {
  name: "members-table",
  components: {
    MembersManagementTable,
  },
  mixins: [planSetter],
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
  },
  methods: {
    /*$t(args) {
        console.log(this.messages, args)
        if (Object.keys(this.messages).indexOf(args) < 0) {
            this.messages[args]="TRANSLATION REQUIRED"
        }
        return "TRANSLATION REQUIRED";
    },*/
  },
};
</script>
